import { ReactNode } from 'react';
import styled from 'styled-components';

import { useI18nValues } from '@/entities/vfo/hooks/useI18nValues';
import { TaskPriority } from '@/entities/vfo/types';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

export const useTaskPriorities = () => {
  const { priority } = useI18nValues();

  const priorities: {
    value: TaskPriority;
    label: ReactNode;
  }[] = [
    {
      value: TaskPriority.HIGH,
      label: (
        <OptionItem>
          <Icon name="caret-double-up" size="s20" style={{ color: COLORS.systemFlame200 }} />
          <span>{priority(TaskPriority.HIGH)}</span>
        </OptionItem>
      ),
    },
    {
      value: TaskPriority.MEDIUM,
      label: (
        <OptionItem>
          <Icon name="equals" size="s20" style={{ color: COLORS.systemSun200 }} />
          <span> {priority(TaskPriority.MEDIUM)}</span>
        </OptionItem>
      ),
    },
    {
      value: TaskPriority.LOW,
      label: (
        <OptionItem>
          <Icon name="caret-double-down" size="s20" style={{ color: COLORS.systemSky200 }} />
          <span>{priority(TaskPriority.LOW)}</span>
        </OptionItem>
      ),
    },
  ];

  const getPriority = (taskPriority: TaskPriority) =>
    priorities.find((item) => item.value === taskPriority);
  return { priorities, getPriority };
};

const OptionItem = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;
